module.exports = __webpack_public_path__ + "media/bet_reset.1da58ed8.mp3";